require('./brokerPlansView.scss')
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { CommercialAdsCCValidated : CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerMyInvestmentsProducts = require('components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const { BrokerCustomProductLoader } = require('components/broker/brokerCustomProductLoader/brokerCustomProductLoader');
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const BrokerInformationAboutProduct = require('components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct');
const {
    BrokerMostPopularOfMonth
} = require('components/broker/brokerMostPopularOfMonth/brokerMostPopularOfMonth');
const { BrokerAttentionPlanStartingModal } = require('components/broker/brokerStartingModal/brokerAttentionPlanStartingModal');
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
const BrokerRiskIndicator = require('components/broker/brokerRiskIndicator/brokerRiskIndicator');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BrokerStocksByContractActions = require('actions/brokerWallets');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const brokerContractState = require('actions/brokerContractState');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @utilites
const { PROC_BROKER_PLANS_PG_NAME } = require('utilities/tagging');
// @constants
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
    MYPROFILE_BROKER_EXPLORE_PLANS_URL,
    MYPROFILE_BROKER_URL,
    TYPE_PLANS,
    BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB,
    BROKER_LANDING_PLANS_PLACE,
} = require('constants/index');

class BrokerPlansView extends React.Component {
    constructor(props) {
        super(props);

        this.handleBuyClick = this.handleBuyClick.bind(this);
        this.buildPlansTabbedContent = this.buildPlansTabbedContent.bind(this);
        this.breadcrumb = [
            {
                text: formatText('plans-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('plans-plans'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { immBrokerMyInvestments } = this.props;
        this.props.getStocksByType();
        this.props.getStocksContracts();
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.setPageInteraction();
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMyInvestments } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;

        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.setPageInteraction();
        }
    }

    setPageInteraction() {
        const { immBrokerMyInvestments } = this.props;
        const productStatus = immBrokerMyInvestments.getIn(['products', 'plans', 'total']) > 0
            ? 'active'
            : 'empty';

        this.setState({
            setProductStatus: true,
        })
        taggingEventHandled(PROC_BROKER_PLANS_PG_NAME, 'productStatusActive', productStatus );
    }

    buildCallMeBackContent() {
        return <BrokerInvestmentSpecialist />;
    }

    buildMostPopularOfMonthContent() {
        return (
            <BrokerMostPopularOfMonth
                defaultTab={BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB}
                deactivateTabsMode={true}
                titleKey="broker-mostPopularOfMonthTitlePlansLanding"
                toolTipContentKey="mostPopularOfMonth-mostPopularOfMonthTooltipPlansLanding"
                pageName={PROC_BROKER_PLANS_PG_NAME}
            />
        );
    }

    getTabContent() {
        const {
            immAccounts,
            immBrokerContractState,
            immBrokerMyInvestments,
            immBrokerWallets,
            getContractState,
            getStocksByContract,
            postWalletAlias,
            onOpenTraderClick,
            setOrdersAndMovementsAccessFrom,
            setOrdersAndMovementsContract,
            immBrokerLandingLoader
        } = this.props;

        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');
        const immStocksByType = immBrokerMyInvestments.get('products');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');

        if (activeTab == 0) {
            return (<BrokerMyInvestmentsProducts
                immStocksByType={immStocksByType}
                isFetchingStocksByType={isFetchingStocksByType}
                setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                displayAlternativeFunds={false}
                displayStocks={false}
                displayWarrants={false}
                displayETFs={false}
                displayFunds={false}
                displayCrypto={false}
                displayPlans={true}
                displayOthers={false}
                startExpanded={true}
                alternativeValueColumnTitle={true}
                displayFooter={false}
                onOpenTraderClick={onOpenTraderClick}
                resetSpecificProduct={this.props.resetSpecificProduct}
                pageName={PROC_BROKER_PLANS_PG_NAME}
            />);
        }

        return (
            <BrokerMyInvestmentsContracts
                getStocksByContract={getStocksByContract}
                immStocksByContract={immStocksByContract}
                immStocksContracts={immStocksContracts}
                immStocksByType={immStocksByType}
                isFetchingStocksByContract={isFetchingStocksByContract}
                postWalletAlias={postWalletAlias}
                displayStocks={false}
                displayFunds={false}
                displayPlans={true}
                displayFooter={false}
                displayCrypto={false}
                setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                onOpenTraderClick={onOpenTraderClick}
                immAccounts={immAccounts}
                immBrokerContractState={immBrokerContractState}
                getContractState={getContractState}
                pageName={PROC_BROKER_PLANS_PG_NAME}
            />);

    }

    buildPlansTabbedContent() {
        const {
            immBrokerMyInvestments,
        } = this.props;

        const immStocksByType = immBrokerMyInvestments.get('products');
        const plans = immStocksByType.get('plans');
        const emptyStocks = !plans || plans.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('plans-myPositions');
        const tab = this.getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }

        return (
            <ContentBox
                id={"brokerPlans"}
                title={title}
                customClassName={"tabbed-content-box broker-my-investments"}
            >
                {tab}
            </ContentBox>
        );
    }

    buildProductInfoContent() {
        const {immBrokerMyInvestments} = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const plans = immStocksByType.get('plans');
        const emptyStocks = !plans || plans.get('stocks').size === 0;

        return (
            <BrokerInformationAboutProduct
                productType={TYPE_PLANS}
                onBuyClick={() => this.handleBuyClick('comercialCard')}
                hasButton={!emptyStocks}
                pageName={PROC_BROKER_PLANS_PG_NAME}
            />
        );
    }

    buildLegalText() {
        const text1 = formatText('broker-plansLegalText1')

        const link1 = (
            <OKLink
                to={formatText('broker-plansLegalLinkUrl')}
                modifier="emphasize"
            >
                <FormattedText value="broker-plansLegalLinkText" />
            </OKLink>
        );


        const text2 = (
            <FormattedTextWithComponents
                value="broker-plansLegalText2"
                injectedComponents={[link1]}
            />
        );

        return (
            <div className="broker-plans-view__legal-text">
                <div className="broker-plans-view__legal-text-paragraph1">
                    {text1}
                </div>
                <div className="broker-plans-view__legal-text-paragraph2">
                    {text2}
                </div>
            </div>
        );
    }

    handleBuyClick(component) {
        taggingEventHandled(PROC_BROKER_PLANS_PG_NAME, component === 'comercialCard' ? 'buyButtonComCard' : 'buyButton');
        this.props.resetSpecificProduct(TYPE_PLANS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_PLANS_URL);
    }

    render() {
        const { immBrokerMyInvestments } = this.props;
        const productInfoContent = this.buildProductInfoContent();
        const callMeBackContent = this.buildCallMeBackContent();
        const mostPopularOfMonthContent = this.buildMostPopularOfMonthContent();
        const plansTabbedContent = this.buildPlansTabbedContent();
        let plansTabbedContentObject = null;
        let plansCTAsObject = null;
        const buySellBtnText = formatText('broker-buySellBtnText');
        const searchButtonText = formatText('brokerSearchWidget-brokerSearchWidget_searchPlans');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const lang = getLanguage().toLowerCase();
        const links = lang === 'es' || lang === 'en' || lang === 'pt'
            ? []
            : [getPublicSiteUrl()];

        let actionLinkButton = (
            <div className="broker-general-view__action-link-btn col-sm-4">
                <OKButton
                    modifier="primary"
                    onClick={this.handleBuyClick}
                >
                    {buySellBtnText}
                </OKButton>
            </div>
        );

        const searchButton = (
            <div className="broker-general-view__action-link-btn col-sm-8">
                <OKButton
                    modifier="secondary"
                    leftIcon="icon-s-buscar"
                    block={true}
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_PLANS_PG_NAME, 'searchButton')
                        this.props.handleShowSearchWidget()
                    }}
                >
                    {searchButtonText}
                </OKButton>
            </div>
        );

        if (!isFetchingStocksByType) {
            if (plansTabbedContent) {
                plansTabbedContentObject = (
                    <div className="row">
                        <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                            <BrokerCustomProductLoader pageName={PROC_BROKER_PLANS_PG_NAME} />
                        </div>
                        <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            {plansTabbedContent}
                        </div>
                    </div>
                );
            } else {
                plansCTAsObject = (
                    <div className="row">
                        <div className="col-md-12 broker-general-view__landing-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                    </div>
                );
            }
        }
        else {
            plansTabbedContentObject = <LoadingSection />
        }
        return (
            <div>
                <div className="broker-general-view__search-widget">
                    <BrokerSearchWidget product={TYPE_PLANS}/>
                </div>
                <BrokerAttentionPlanStartingModal place={BROKER_LANDING_PLANS_PLACE} />
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="plans-title"
                                breadcrumbConfig={this.breadcrumb}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="broker-funds-view__broker-risk-indicator">
                            <BrokerRiskIndicator
                                links={links}
                                hasAlert={true}
                                typeAlert="liquidity"
                                textContent="brokerRiskInformationBox-brokerRiskInformationBox_descriptionPlans"
                                productType="Plans"
                            />
                        </div>
                        {plansTabbedContentObject}
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    <div className={`col-md-12 ${ plansTabbedContent ? 'grid-view--fix-cell-separation' : ''}`}>
                                        {productInfoContent}
                                    </div>
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        {mostPopularOfMonthContent}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                {plansCTAsObject}
                                <div className="row">
                                    {/* <div className="col-md-12 grid-view--fix-cell-separation">
                                        <FeatureTogglingRender notAllowedProductKey={FUNDS_RISK_INDICATOR} >
                                            <BrokerRiskInformationBox riskType={BROKER_RISK_TYPE_SEVEN}  maxRiskValue={maxRiskValue} hasLiquidityAlert={true} links={links} descriptionKey="brokerRiskInformationBox-brokerRiskInformationBox_descriptionPlans" />
                                        </FeatureTogglingRender>
                                    </div> */}
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        {callMeBackContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 grid-view__sources">
                                {this.buildLegalText()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        <CommercialAds path="broker/general" type="cross-selling" />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerPlansView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerContractState: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    getContractState: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    handleShowSearchWidget: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func
};

module.exports.constructor = BrokerPlansView;
module.exports.BrokerPlansView = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerWallets: state.brokerWallets,
        immBrokerLandingLoader: state.brokerLandingLoader,
        immAccounts: state.accounts
    }),
    {
        getContractState: brokerContractState.getContractState,
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,

    }
)(withRouter(BrokerPlansView));
